
export const fetchOutletBehaviorBarChartData = async (payload, request) => {
 
    try {
        const response = await request("POST", `/v1/survey/dashboard/bar-chart`, { data: { "locationId": payload.locationId, "surveyId": payload.surveyId } }, "survey_service");
        return response

    } catch (error) {
        console.log(error)
    }

};